/* --------------------------------------------------------------------------------------
   xrxWrappers.js
   Copyright © 2018 Xerox Corporation. All Rights Reserved. 
   
   Copyright protection claimed includes all forms and matters of copyrightable material 
   and information now allowed by statutory or judicial law or hereinafter granted, 
   including without limitation, material generated from the software programs which 
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

import { xwButton } from './xwButton.directive'
import { xwSegmented } from './xwSegmented.directive'
import { xwToggleSwitch } from './xwToggleSwitch.directive'
import { xwAlert } from './xwAlert.directive'
import { xwPopup } from './xwPopup.directive'
import { xwPopover } from './xwPopover.directive'
import { xwKeyboard } from './xwKeyboard.directive'
import { xwTable } from './xwTable.directive'
import { xwScrollable } from './xwScrollable.directive'
import { xwActivity } from './xwActivity.directive'
import { xwBanner } from './xwBanner.directive'

export const appXrxWrappersModule = angular.module('app.xrxWrappers',[])
.directive('xwButton', xwButton.directiveFactory)
.directive('xwSegmented', xwSegmented.directiveFactory)
.directive('xwToggleSwitch', xwToggleSwitch.directiveFactory)
.directive('xwAlert', xwAlert.directiveFactory)
.directive('xwPopup', xwPopup.directiveFactory)
.directive('xwPopover', xwPopover.directiveFactory)
.directive('xwKeyboard', xwKeyboard.directiveFactory)
.directive('xwTable', xwTable.directiveFactory)
.directive('xwScrollable', xwScrollable.directiveFactory)
.directive('xwActivity', xwActivity.directiveFactory)
.directive('xwBanner', xwBanner.directiveFactory)



// WEBPACK FOOTER //
// ./src/app/xrxWrappers/xrxWrappers.js